import { useEffect, useState } from 'react';
import { getPublicPage } from '../api/contentApi';
import { resolveSolutionDetailContent } from '../utils/solutionDetailFallback';

export const useSolutionDetailContent = (slug, solution) => {
  const [content, setContent] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const load = async () => {
      setIsLoading(true);

      try {
        const page = await getPublicPage(slug);
        if (!isMounted) {
          return;
        }

        setContent(resolveSolutionDetailContent(page, solution));
        setError(null);
      } catch (err) {
        if (!isMounted) {
          return;
        }

        setContent(solution ? resolveSolutionDetailContent(null, solution) : null);
        setError(err);
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    if (slug && solution) {
      load();
    } else {
      setContent(null);
      setIsLoading(false);
    }

    return () => {
      isMounted = false;
    };
  }, [slug, solution]);

  return { content, isLoading, error };
};
